import { IDefineCommand, IQuery } from 'core-ts-types';
import { AccountModel } from 'data-ng-authentication';
import { IDatasource, ORM } from 'utility-ts-orm';
import { Conversation } from '../builders/conversation_builder';
import { ConversationThread } from '../builders/conversation_thread_builder';
import { IConversationDatasourceModel } from '../conversations_interface';

angular
  .module('capability-ng-conversations')
  .factory(
    'deleteConversationThreadCommand',
    (
      accountModel: AccountModel,
      ngConversationThreadDatastore: IDatasource<ConversationThread>,
      ngConversationDatastore: IDatasource<Conversation, IConversationDatasourceModel>,
      $http: ng.IHttpService,
      defineCommand: IDefineCommand
    ) => {
      return defineCommand(
        'deleteConversationThreadCommand',
        (deferred: ng.IDeferred<IQuery[]>, thread: ConversationThread) => {
          $http.delete(`notification/students/${accountModel.student_nk}/messages/${thread.id}`).then((): void => {
            ngConversationThreadDatastore.del(thread);
            if (ngConversationThreadDatastore.size() === 0) {
              ngConversationDatastore.del(thread.id);
            }
            ORM.run();
            deferred.resolve();
          });
        }
      );
    }
  );



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-conversations/src/commands/delete_conversation_thread_command.ts